export default {
    accountStepTitle:"Account",
    accountStepActionLabel:"Continue",
    paymentStepTitle:"Payment",
    ikeepayPaymentMethodTitle:"Secure payment with Ikeepay",
    ikeepayPaymentMethodDescription:"Mobile money or card, chosen in the next window",
    ikeepayCheckoutErrorMessage:"The payment window could not be opened. Please try again.",
    confirmStepTitle:"Confirm",
    confirmStepActionLabel:"Confirm",
    confirmStepSubTitle:"Review & Confirm",
    confirmStepDescription:"Check your details before completing payment",
    confirmAndPayStepActionLabel:"Confirm & Pay {{localizedAmount}}",
    editStepDetailActionLabel:"Edit",
    subscriptionPlanCardTitle:"Order Summary",
    subscriptionPlanCardDescription:"Select a plan",
    subscriptionPlanCardTotalLabel:"Total",
    checkoutPagePlatformDisclaimer:"This platform is for educational purposes only and is not affiliated with any official testing organization.",
    confirmCheckoutInfoNotice: "By confirming, you agree to our <terms> Terms of service</terms>",
    confirmCheckoutInfoAndPayNotice:"By confirming, you agree to our <terms> Terms of service</terms> and authorize a payment of <bold>{{localizedPrice}}</bold> via Ikeepay. A secure payment window will open to complete it.",
    previousCheckoutStepActionLabel: "Previous",
}